import { Box, useTheme } from '@mui/material';
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';
import React, { FC } from 'react';
import { SxProps, Theme } from '@mui/system';

import { loader } from './styles';

interface FileLoaderProps {
  loaderStyle?: SxProps<Theme>;
  customColor?: string;
}
const FileLoaderComponent: FC<FileLoaderProps> = props => {
  const { customColor } = props;
  const theme = useTheme();

  return (
    <Box sx={loader}>
      <CircularProgress
        sx={{
          color: theme.palette.grey[300],
        }}
        variant='determinate'
        size={30}
        thickness={4}
        value={100}
      />
      <CircularProgress
        variant='indeterminate'
        disableShrink
        sx={{
          color: customColor ?? 'primary',
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={30}
        thickness={4}
      />
    </Box>
  );
};
export default FileLoaderComponent;
